@if (shouldDisplaySectionsConfig.streetAddress1) {
    <div class="details">
        <h-shop-info-title
            [headerLevelShopTitle]="headerLevelShopTitle + 1"
            [isScreenReaderOnly]="true"
            [class.initially-hidden-section]="hiddenSections.has('streetAddress1')"
            i18n="@@hermes-global-translations.stores.location">
            Location
        </h-shop-info-title>

        <div [class.address-with-icon-link]="directionLinkMode === 'icon'">
            <div class="address-row">
                <h-svg-icon [name]="'pin-minimalist'"></h-svg-icon>
                <h-shop-address class="paragraph-small" [shop]="shop"></h-shop-address>
            </div>

            @if (directionLinkMode === "icon") {
                <h-shop-info-direction
                    [mode]="'icon'"
                    [shop]="shop"
                    [meters]="meters"
                    [directionUrl]="directionUrl"
                    [headerLevelShopTitle]="headerLevelShopTitle"
                    (shopInfoDirectionEvents)="shopInfoDirectionEvents.emit($event)">
                </h-shop-info-direction>
            }
        </div>
        @if (directionLinkMode === "text") {
            <h-shop-info-direction
                class="text-link"
                [mode]="'text'"
                [shop]="shop"
                [headerLevelShopTitle]="headerLevelShopTitle"
                (shopInfoDirectionEvents)="shopInfoDirectionEvents.emit($event)"></h-shop-info-direction>
        }
    </div>
}
@if (shouldDisplaySectionsConfig.phoneNumber) {
    <div class="details">
        <h-shop-info-title
            [headerLevelShopTitle]="headerLevelShopTitle + 1"
            [isScreenReaderOnly]="true"
            [class.initially-hidden-section]="hiddenSections.has('phoneNumber')"
            i18n="@@hermes-global-translations.stores.phone-number">
            Phone number
        </h-shop-info-title>

        <div class="details-content">
            <h-svg-icon [name]="'phone'"></h-svg-icon>

            <ul>
                <li class="paragraph-small" data-testid="shop-tel">
                    <a
                        class="underline"
                        (click)="shopInfoDetailsEvents.emit('phone')"
                        href="tel:{{ shop.phoneNumber }}">
                        {{ shop.phoneNumber }}
                    </a>
                </li>
                @if (shop.faxNumber) {
                    <li class="paragraph-small">
                        <a
                            class="underline"
                            (click)="shopInfoDetailsEvents.emit('fax')"
                            href="tel:{{ shop.faxNumber }}">
                            {{ shop.faxNumber }}
                        </a>
                    </li>
                }
            </ul>
        </div>
    </div>
}
@if (shouldDisplaySectionsConfig.openingHours) {
    <div class="details">
        <h-shop-info-title
            [headerLevelShopTitle]="headerLevelShopTitle + 1"
            [isScreenReaderOnly]="true"
            [class.initially-hidden-section]="hiddenSections.has('openingHours')"
            i18n="@@page-hermes-product-locator-accessibility-find-in-store-hours">
            Opening/Closing hours
        </h-shop-info-title>
        <div class="details-content">
            <h-svg-icon [name]="'clock'"></h-svg-icon>

            <ul class="paragraph-small" [innerHTML]="shop.openingHours" data-testid="opening-closing-hours"></ul>
        </div>
    </div>
}
@if (shouldDisplaySectionsConfig.additionalInformation) {
    <div class="details no-icon">
        <h-shop-info-title
            [headerLevelShopTitle]="headerLevelShopTitle + 1"
            [isScreenReaderOnly]="true"
            [class.initially-hidden-section]="hiddenSections.has('additionalInformation')"
            i18n="@@hermes-global-translations.title-additional-information">
            Additional information
        </h-shop-info-title>
        <div class="details-content">
            <div
                class="additional-information-shop"
                [innerHTML]="shop.additionalInformation"
                data-testid="shop-additional-information">
            </div>
        </div>
    </div>
}
@if (hiddenSections.size > 0) {
    <h-action-button
        (click)="toggleDetails()"
        [attr.aria-controls]="'more-detail-content'"
        [attr.aria-expanded]="isDetailOpen"
        class="more-details-button no-icon"
        [class.button-open]="isDetailOpen"
        [size]="'medium'"
        data-testid="more-details-link">
        @if (!isDetailOpen) {
            <ng-container i18n="@@page-hermes-product-locator-more-details-open-toggle"> More details</ng-container>
        }
        @if (isDetailOpen) {
            <ng-container i18n="@@page-hermes-product-locator-more-details-close-toggle"> Close details</ng-container>
        }
    </h-action-button>
}
@if (shouldDisplaySectionsConfig.appointmentInStore) {
    <div class="details no-icon appointment-in-stores">
        <h-call-to-action
            class="appointment-button"
            (click)="navigateToAppointment(shop.url)"
            [dataTestId]="'Book an appointment'"
            i18n="@@hermes.appointment_in_store.button.book_appointment">
            Book an appointment
        </h-call-to-action>
    </div>
}
